import { Avatar, AvatarContent, AvatarDescription, AvatarImage, AvatarTitle } from '@playbooks/ui/components/avatar';
import { Link } from '@playbooks/ui/components/link';

export const RatingAvatar = ({ thumbnail, title, children, href }) => (
	<Link variant='ghost' href={href} className='group h-auto p-0'>
		<Avatar className='flex-start'>
			<AvatarImage size='md' src={thumbnail} alt={title} />
			<AvatarContent>
				<AvatarTitle className='text-base font-semibold group-hover:underline'>{title}</AvatarTitle>
				<AvatarDescription className='text-sm font-light'>{children}</AvatarDescription>
			</AvatarContent>
		</Avatar>
	</Link>
);
